module.exports = __webpack_public_path__ + "media/bootstrap-icons/slash-lg-68cbb453.svg";